import { Component, Input, OnInit } from '@angular/core';
import { first, forkJoin } from 'rxjs';
import { DashboardKpiService } from '../../../services/dashboard-kpi.service';
import { SalesSummaryEntity, Timespan } from '../../../types';

@Component({
    selector: 'lib-last-vs-this-year-offer-amount-summary-card',
    templateUrl: './last-vs-this-year-offer-amount-summary-card.component.html',
    styleUrls: ['./last-vs-this-year-offer-amount-summary-card.component.css'],
    standalone: false
})
export class LastVsThisYearOfferAmountSummaryCardComponent implements OnInit {

  numberOffersThisYear = 0;
  numberOffersLastYear = 0;
  loaded = false;
  @Input()
  preConditions: any;

  constructor(protected dashboardKpiService: DashboardKpiService) {}

  ngOnInit() {
    const thisYearSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.Year);
    const lastYearSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.LastYear);

    forkJoin({
      offersSummaryGroupsThisYear: this.dashboardKpiService
        .getOfferSummary(SalesSummaryEntity.MAIN_ENTITY, thisYearSpan.fromDate, null, this.preConditions)
        .pipe(first()),
      offersSummaryGroupsLastYear: this.dashboardKpiService
        .getOfferSummary(SalesSummaryEntity.MAIN_ENTITY, lastYearSpan.fromDate, lastYearSpan.toDate, this.preConditions)
        .pipe(first())
    }).subscribe(({ offersSummaryGroupsThisYear, offersSummaryGroupsLastYear}) => {
      this.numberOffersLastYear = offersSummaryGroupsLastYear.length;
      this.numberOffersThisYear = offersSummaryGroupsThisYear.length;
      this.loaded = true;
    });
  }
}
